import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Footer.css';

function Footer() {
  const [footerData, setFooterData] = useState(null);

  useEffect(() => {
    // Fetch data from data.json
    axios.get('/data/data.json')
      .then((response) => {
        setFooterData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching footer data:', error);
      });
  }, []);

  // Show a loading state while data is being fetched
  if (!footerData) {
    return <div>Loading Footer...</div>;
  }

  return (
    <footer className="footer">
      <div className="footer__bg">
        <div className="footer__container container grid">
          <div>
            <h1 className="footer__title">{footerData.name}</h1>
            <span className="footer__subtitle">{footerData.title}</span>
          </div>

          <ul className="footer__links">
            <li><a href="#about" className="footer__link">About</a></li>
            <li><a href="#skills" className="footer__link">Skills</a></li>
            <li><a href="#work" className="footer__link">Work</a></li>
            <li><a href="#contact" className="footer__link">Contact me</a></li>
          </ul>

          <div className="footer__socials">
            <a href={footerData.socialMedia.facebook} target="_blank" rel="noopener noreferrer" className="footer__social">
              <i className="uil uil-facebook-f"></i>
            </a>
            <a href={footerData.socialMedia.twitter} target="_blank" rel="noopener noreferrer" className="footer__social">
              <i className="uil uil-twitter"></i>
            </a>
            <a href={footerData.socialMedia.github} target="_blank" rel="noopener noreferrer" className="footer__social">
              <i className="uil uil-github"></i>
            </a>
          </div>
        </div>

        <p className="footer__copy">&#169; {footerData.name}. All rights reserved</p>
      </div>
    </footer>
  );
}

export default Footer;
